import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import Utility from "../../utility/Utility";

export default class ActivityManager {

  static status = {
    CALL: 1,
    MEETING: 2,
    TASK: 3,
    DEADLINE: 4,
    EMAIL: 5,
    LUNCH: 6,
  };

  static getActivityTypeColor = (type) => {
    switch (type-1) {
      case ActivityManager.status.CALL:
        return "data-grid-badge-color-6"
      case ActivityManager.status.TASK:
        return "data-grid-badge-color-5";
      case ActivityManager.status.MEETING:
        return "data-grid-badge-color-7";
      case ActivityManager.status.EMAIL:
        return "data-grid-badge-color-8";
      case ActivityManager.status.LUNCH:
        return "data-grid-badge-color-2";
      case ActivityManager.status.DEADLINE:
        return "data-grid-badge-color-10";
      default:
        return "data-grid-badge-color-1";
    }
  }


  static getQuery(type, id) {
    let date = new Date()
    let todayDateString = date.toISOString().substring(0, 10) + "T00:00:00Z"
    let addDate = date.setDate(date.getDate() + 1)
    let nextDateString = new Date(addDate).toISOString().substring(0, 10) + "T00:00:00Z"
    let todayQuery = { "logicalOperator": "and", "conditions": [{ colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.LINKED_TO), value: [id], opr: "in" }, { colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE), value: todayDateString, opr: "gte" }, { colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE), value: nextDateString, opr: "lt" }] }

    let pastQuery = { "logicalOperator": "and", "conditions": [{ colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.LINKED_TO), value: [id], opr: "in" }, { colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE), value: todayDateString, opr: "lte" }] }

    let futureQuery = { "logicalOperator": "and", "conditions": [{ colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.LINKED_TO), value: [id], opr: "in" }, { colId: ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE), value: nextDateString, opr: "gte" }] }

    let personQuery = { "logicalOperator": "and", "conditions": [{ colId: ActivityManager.getColumnId(COLUMN_CODE.CANDIDATE.TYPE, TABLES.CANDIDATE), value: "1", opr: "c" }] }

    let orgQuery = { "logicalOperator": "and", "conditions": [{ colId: ActivityManager.getColumnId(COLUMN_CODE.CANDIDATE.TYPE, TABLES.CANDIDATE), value: "2", opr: "c" }] }

    switch (type) {
      case 'todayQuery': return todayQuery
      case 'pastQuery': return pastQuery
      case 'futureQuery': return futureQuery
      case 'personQuery': return personQuery
      case 'orgQuery': return orgQuery
      default: return
    }

  }
  static getTableId() {
    return TableManger.getTableId(TABLES.ACTIVITY);
  }

  static getColumnId(columnCode, table) {
    return TableManger.getColumnId(table ? table : TABLES.ACTIVITY, columnCode);
  }

  static createRequestJson(formData) {
    let data = {};
    let startDate = new Date(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.START_DATE))
    let endDate = new Date(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.END_DATE))
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.NAME)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.NAME);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE)] = startDate.toISOString();
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.END_DATE)] = endDate.toISOString();
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.NOTES)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.NOTES);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS)] = Utility.isEmpty(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS)) ? [] : ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.CONTACT_IDS)] = Utility.isEmpty(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.CONTACT_IDS)) ? [] : ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.CONTACT_IDS);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS)] = Utility.isEmpty(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS)) ? [] : ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.LINKED_TO)] = Utility.isEmpty(ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.LINKED_TO)) ? [] : ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.LINKED_TO);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.STATUS)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.STATUS);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.SEND_INVITATION)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.SEND_INVITATION);
    data[this.getColumnId(COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION)] = ActivityManager.getFieldData(formData, COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION);
    return data;
  }

  static getFieldData(data, key) {
    let value = data.find(field => field.key === key)
    return Utility.isEmpty(value) ? "" : value.value;
  }

  static activityData = (activities) => {
    let activitylist = []
    let pendingCount = 0
    activities.forEach(activity => {
      let fields = {
        id: activity._id,
        [COLUMN_CODE.ACTIVITY.NAME]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.NAME)],
        [COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE)],
        [COLUMN_CODE.ACTIVITY.START_DATE]: new Date(activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.START_DATE)]),
        [COLUMN_CODE.ACTIVITY.END_DATE]: new Date(activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.END_DATE)]),
        [COLUMN_CODE.ACTIVITY.NOTES]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.NOTES)],
        [COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS)],
        [COLUMN_CODE.ACTIVITY.CONTACT_IDS]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.CONTACT_IDS)],
        [COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS)],
        [COLUMN_CODE.ACTIVITY.LINKED_TO]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.LINKED_TO)],
        [COLUMN_CODE.ACTIVITY.STATUS]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.STATUS)],
        [COLUMN_CODE.ACTIVITY.SEND_INVITATION]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.SEND_INVITATION)],
        [COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION]: activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION)]
      }
      if (activity.cells[this.getColumnId(COLUMN_CODE.ACTIVITY.STATUS)] === false) {
        pendingCount = pendingCount + 1
      }
      activitylist.push(fields)
    })

    return { activitylist, pendingCount }
  }

  static dealData = (deals) => {
    let deallist = []
    deals.forEach(deal => {
      let fields = {
        id: deal._id,
        [COLUMN_CODE.DEAL.NAME]: deal.cells[this.getColumnId(COLUMN_CODE.DEAL.NAME, TABLES.DEAL)],
      }
      deallist.push(fields)
    })
    return deallist
  }

  static contactData = (contacts) => {
    let contactlist = []
    contacts.forEach(contact => {
      let fields = {
        id: contact._id,
        [COLUMN_CODE.CANDIDATE.NAME]: contact.cells[this.getColumnId(COLUMN_CODE.CANDIDATE.NAME, TABLES.CANDIDATE)],
      }
      contactlist.push(fields)
    })
    return contactlist
  }

  static getActivityType = (type) => {
    switch (type-1) {
      case ActivityManager.status.CALL:
        return "Call"
      case ActivityManager.status.TASK:
        return "Task";
      case ActivityManager.status.MEETING:
        return "Meeting";
      case ActivityManager.status.EMAIL:
        return "Email";
      case ActivityManager.status.LUNCH:
        return "Lunch";
      case ActivityManager.status.DEADLINE:
        return "Deadline";
      default:
        return "Call";
    }
  }
}
